module.exports = __webpack_public_path__ + "img/fruit_snakeberry.90f25a12.png";